import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Instagram, Youtube, Music, Headphones } from 'lucide-react';
import PageTransition from './PageTransition';
import CustomCursor from './CustomCursor';

const socials = [
  {
    id: 1,
    name: 'instagram',
    icon: Instagram,
    url: 'https://www.instagram.com/jambluness/',
    color: '#E4405F',
    handle: '@jambluness'
  },
  {
    id: 2,
    name: 'youtube',
    icon: Youtube,
    url: 'https://www.youtube.com/@jamblu8447/videos',
    color: '#FF0000',
    handle: '@jamblu8447'
  },
  {
    id: 3,
    name: 'bandcamp',
    icon: Music,
    url: 'http://jamblu.bandcamp.com',
    color: '#1DA0C3',
    handle: 'jamblu'
  },
  {
    id: 4,
    name: 'spotify',
    icon: Headphones,
    url: 'https://open.spotify.com/artist/1B4LXSUI2AxxDVeroz5WI0?si=xy-TNHceT5qfBP_GZlImAw',
    color: '#1DB954',
    handle: 'jamblu'
  },
  {
    id: 5,
    name: 'apple music',
    icon: Music,
    url: 'https://music.apple.com/in/artist/jamblu/1073178893',
    color: '#FC3C44',
    handle: 'jamblu'
  }
];

const SocialsPage = () => {
  const navigate = useNavigate();
  const [hoveredOrb, setHoveredOrb] = useState(null);
  const [orbAngles, setOrbAngles] = useState(socials.map((_, i) => (i * 360 / socials.length)));

  // Animate orbs slowly
  useEffect(() => {
    const interval = setInterval(() => {
      setOrbAngles(prev => prev.map(angle => (angle + 0.3) % 360));
    }, 50);
    return () => clearInterval(interval);
  }, []);

  const getOrbPosition = (index) => {
    const angle = orbAngles[index];
    const radian = (angle * Math.PI) / 180;
    const radius = 180;
    const x = Math.cos(radian) * radius;
    const y = Math.sin(radian) * (radius * 0.4);
    return { x, y };
  };

  return (
    <PageTransition>
      <CustomCursor />
      <div className="socials-page">
        {/* Background */}
        <div className="socials-bg">
          {[...Array(40)].map((_, i) => (
            <div
              key={i}
              className="social-star"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`
              }}
            />
          ))}
        </div>

        {/* Header */}
        <header className="socials-header">
          <button className="socials-close" onClick={() => navigate('/')}>
            <X size={24} />
          </button>
          <h1>socials</h1>
          <div style={{ width: 50 }} />
        </header>

        {/* Orbiting Orbs */}
        <div className="socials-orbit-container">
          <div className="orbit-ring" />
          <div className="orbit-center">
            <span>j</span>
          </div>
          
          {socials.map((social, index) => {
            const Icon = social.icon;
            const pos = getOrbPosition(index);
            const isHovered = hoveredOrb === social.id;
            
            return (
              <a
                key={social.id}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`social-orb ${isHovered ? 'hovered' : ''}`}
                style={{
                  '--orb-x': `${pos.x}px`,
                  '--orb-y': `${pos.y}px`,
                  '--orb-color': social.color
                }}
                onMouseEnter={() => setHoveredOrb(social.id)}
                onMouseLeave={() => setHoveredOrb(null)}
              >
                <div className="orb-glow" />
                <div className="orb-icon">
                  <Icon size={24} />
                </div>
                <div className="orb-label">
                  <span className="orb-name">{social.name}</span>
                  <span className="orb-handle">{social.handle}</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </PageTransition>
  );
};

export default SocialsPage;
